import { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { Input } from 'antd';
import { useLocation } from 'react-router-dom';
import RichEditor from '@components/common/RichEditor';
import { useSurveyAutosave } from '../../SurveyAutosaveContext';
import { applyQuestionStemFocusBorder, clearQuestionStemFocusBorder } from '../richEditorFocusHelpers';
import { useQuestionStemAutosave } from '../useQuestionStemAutosave';
import { saveQuestionStemBody } from '../saveQuestionStemBody';

const Answer = ({ questionId, item, setAnserArea, anserArea }) => {
    const { notifySaved } = useSurveyAutosave();
    const { TextArea } = Input;
    const [questionIndex, setQuestionIndex] = useState();
    const [titleBorder, setTitleBorder] = useState(false);
    const [titleIn, setTitleIn] = useState(false);
    const [bodyHtml, setBodyHtml] = useState(item.body);
    const location = useLocation();
    const { pathname } = location;
    const editorRootRef = useRef(null);
    const anserAreaRef = useRef(anserArea);

    useEffect(() => {
        anserAreaRef.current = anserArea;
    }, [anserArea]);

    useEffect(() => {
        setBodyHtml(item.body);
    }, [item.body]);

    useEffect(() => {
        const index = anserArea.findIndex(it => it.id === item.id);
        setQuestionIndex(index + 1);
    }, [anserArea, item.id]);

    const onPersist = useCallback(
        async nextBody => {
            const ok = await saveQuestionStemBody({
                item,
                nextBody,
                anserArea: anserAreaRef.current,
                locationState: location.state,
                pathname,
            });
            if (ok) {
                notifySaved();
            }
            return ok;
        },
        [item, location.state, pathname, notifySaved],
    );

    const { schedule, flush } = useQuestionStemAutosave({
        itemId: item.id,
        remoteBody: item.body,
        onPersist,
    });

    const handleStemChange = useCallback(
        html => {
            setBodyHtml(html);
            schedule(html);
        },
        [schedule],
    );

    const changeTitle = (_editor, latestHtml) => {
        const nextBody = latestHtml != null ? latestHtml : bodyHtml;
        const root = editorRootRef.current;
        if (root) {
            clearQuestionStemFocusBorder(root);
        }
        setBodyHtml(nextBody);
        setTitleBorder(false);
        flush(nextBody);
    };

    const getBorder = () => {
        const root = editorRootRef.current;
        if (root) {
            applyQuestionStemFocusBorder(root);
        }
        setTitleBorder(true);
        setTitleIn(true);
    };

    return (
        <Fragment>
            <div name={questionId}>
                <div className="question-title">
                    <div className="question-id">
                        <span
                            className="required"
                            style={{
                                display: item.required === 1 ? '' : 'none',
                            }}
                        >
                            *
                        </span>
                        <b className="question-index">{questionIndex}.</b>
                    </div>
                    <div ref={editorRootRef} onMouseDown={e => e.stopPropagation()}>
                        <RichEditor id={`wj-answer-question-${item.id}`} mode="simple" inline value={bodyHtml} onChange={handleStemChange} placeholder="请输入问题" className="question-title-area" height={128} onEditorFocus={getBorder} onEditorBlur={changeTitle} />
                    </div>
                </div>
                <div className="fill-answer">
                    <TextArea
                        disabled
                        autoSize={{
                            minRows: 3,
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default Answer;
